<div class="bg-[#F8FAFC] min-h-screen">

    <!-- Hero Section -->
    <section class="relative h-[300px] md:h-[360px] bg-cover bg-center overflow-hidden z-10"
        style="background-image: url('/assets/visidea/banner_slide.jpg');">
        <!-- Gradient Overlay -->
        <div class="absolute inset-0 bg-gradient-to-r from-[#1B1E5B]/95 via-[#202367]/90 to-black/75"></div>

        <!-- Content -->
        <div
            class="relative h-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col justify-center items-center text-center text-white space-y-3">
            <h1 class="text-2xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight max-w-3xl mx-auto">
                Paket All In one
                <span class="text-emerald-400">
                    Hemat & Eksklusif
                </span>
            </h1>
            <p class="text-sm md:text-base text-gray-200 max-w-2xl mx-auto font-light leading-relaxed">
                Nikmati keseruan acara bareng Undangan Digital, Buku
                Tamu Digital dan Photobooth dengan diskon 10%.
            </p>
        </div>
    </section>

    <!-- Packages Section with Matching Palette -->
    <section class="relative py-14 md:py-20 px-4 sm:px-6 lg:px-8 overflow-hidden">

        <!-- Ambient Background Glow & Blur (Visidea Blue/Navy Palette) -->
        <div class="absolute inset-0 bg-gradient-to-b from-[#F0F5FA] via-[#F6F9FD] to-[#FFFFFF] -z-20"></div>
        <div class="absolute top-10 left-1/4 w-96 h-96 bg-blue-100/40 rounded-full blur-3xl -z-10 pointer-events-none">
        </div>
        <div
            class="absolute bottom-10 right-1/4 w-96 h-96 bg-indigo-100/30 rounded-full blur-3xl -z-10 pointer-events-none">
        </div>

        <div class="max-w-7xl mx-auto">

            <!-- Section Header -->
            <div class="text-center space-y-2 mb-12 md:mb-14">
                <div
                    class="inline-block bg-[#EEF4FF] text-[#2563EB] px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-widest">
                    Pilihan Bundling Paket
                </div>
                <h2 class="text-2xl sm:text-3xl md:text-4xl font-extrabold text-[#102B51] tracking-tight">
                    Pilih paket yang pas buat acaramu
                </h2>
                <p class="text-gray-500 text-xs sm:text-sm md:text-base max-w-2xl mx-auto">
                    Pilihan paket terbaik untuk melengkapi momen bahagia
                    pernikahan dan event spesial kamu
                </p>
            </div>

            <!-- Loading Skeleton State -->
            <div *ngIf="isLoading" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
                <div *ngFor="let i of [1, 2, 3]"
                    class="bg-white/80 rounded-[28px] p-6 sm:p-7 border border-gray-100 shadow-sm animate-pulse space-y-4">
                    <div class="w-12 h-12 bg-slate-200 rounded-2xl"></div>
                    <div class="h-6 bg-slate-200 rounded-md w-3/4"></div>
                    <div class="h-4 bg-slate-100 rounded-md w-1/2"></div>
                    <div class="space-y-2 pt-4">
                        <div class="h-4 bg-slate-100 rounded w-full"></div>
                        <div class="h-4 bg-slate-100 rounded w-5/6"></div>
                        <div class="h-4 bg-slate-100 rounded w-4/5"></div>
                    </div>
                    <div class="pt-8 flex justify-between items-center">
                        <div class="h-8 bg-slate-200 rounded w-1/3"></div>
                        <div class="w-11 h-11 bg-slate-200 rounded-2xl"></div>
                    </div>
                </div>
            </div>

            <!-- Dynamic Package Cards Grid -->
            <div *ngIf="!isLoading"
                [ngClass]="bundlingPackages.length === 3 ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 items-start' : 'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 lg:gap-7 items-start'">

                <div *ngFor="let pkg of bundlingPackages"
                    class="relative bg-white/95 backdrop-blur-sm rounded-[28px] p-6 sm:p-7 shadow-[0_10px_35px_rgba(0,0,0,0.06)] border border-gray-100/90 flex flex-col justify-between overflow-hidden transition-all duration-300 hover:shadow-xl group"
                    [ngClass]="{'xl:-translate-y-3 xl:shadow-[0_22px_50px_rgba(37,99,235,0.12)] border-[#2563EB]/40 ring-2 ring-[#2563EB]/20': pkg.isFeatured}">

                    <!-- Diagonal Ribbon Badge on Top-Right -->
                    <div class="absolute top-0 right-0 w-28 h-28 overflow-hidden pointer-events-none z-20">
                        <div
                            class="absolute top-5 -right-9 w-32 py-1 bg-gradient-to-r from-[#102B51] via-[#202367] to-[#2563EB] text-white font-black text-[11px] sm:text-xs text-center transform rotate-45 shadow-md tracking-wider uppercase">
                            {{ pkg.discountPercent }}
                        </div>
                    </div>

                    <!-- Card Content -->
                    <div class="flex-1 flex flex-col justify-between">
                        <!-- Top: Icon, Titles, Category & Features -->
                        <div class="flex-1 flex flex-col">
                            <!-- Package Icon -->
                            <div class="h-12 flex items-center">
                                <!-- Icon 1: Hand Click Heart -->
                                <svg *ngIf="pkg.iconType === 'click-heart'" class="w-10 h-10" viewBox="0 0 48 48"
                                    fill="none">
                                    <path
                                        d="M13 13C11.5 11.5 9 12 9 14.5C9 17 13 20 13 20C13 20 17 17 17 14.5C17 12 14.5 11.5 13 13Z"
                                        fill="#2563EB" stroke="#1D4ED8" stroke-width="1.8" />
                                    <path
                                        d="M22 17V27M22 17C22 15 20.2 13.5 18 13.5C15.8 13.5 14 15 14 17V29C14 35 18.5 39 24.5 39C30.5 39 35 35 35 29V23C35 21 33.2 19.5 31.2 19.5C30.2 19.5 29.3 20 28.7 20.6C28.2 19.8 27.2 19.5 26.2 19.5C25.4 19.5 24.6 19.8 24 20.4V17Z"
                                        stroke="#2563EB" stroke-width="2.6" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>

                                <!-- Icon 2: Thumbs Up with Heart -->
                                <svg *ngIf="pkg.iconType === 'thumbs-up'" class="w-10 h-10" viewBox="0 0 48 48"
                                    fill="none">
                                    <path
                                        d="M17 10C15.5 8.5 13 9 13 11.5C13 14 17 17 17 17C17 17 21 14 21 11.5C21 9 18.5 8.5 17 10Z"
                                        fill="#2563EB" stroke="#1D4ED8" stroke-width="1.8" />
                                    <path
                                        d="M14 21V37H8V21H14ZM14 21L21 13C22.5 13 24 14.5 24 16.5V21H35.5C37.5 21 38.5 22.5 38 24.5L35.2 36C34.7 37.5 33.2 38.5 31.7 38.5H14"
                                        stroke="#2563EB" stroke-width="2.6" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>

                                <!-- Icon 3: Heart Eyes Smiling Face -->
                                <svg *ngIf="pkg.iconType === 'heart-eyes'" class="w-10 h-10" viewBox="0 0 48 48"
                                    fill="none">
                                    <circle cx="24" cy="24" r="18" stroke="#2563EB" stroke-width="2.6" />
                                    <path
                                        d="M18 19C16.8 17.8 14.8 18.2 14.8 20.2C14.8 22.2 18 24.6 18 24.6C18 24.6 21.2 22.2 21.2 20.2C21.2 18.2 19.2 17.8 18 19Z"
                                        fill="#2563EB" stroke="#1D4ED8" stroke-width="1.2" />
                                    <path
                                        d="M30 19C28.8 17.8 26.8 18.2 26.8 20.2C26.8 22.2 30 24.6 30 24.6C30 24.6 33.2 22.2 33.2 20.2C33.2 18.2 31.2 17.8 30 19Z"
                                        fill="#2563EB" stroke="#1D4ED8" stroke-width="1.2" />
                                    <path d="M17 29.5C19 33 29 33 31 29.5" stroke="#2563EB" stroke-width="2.6"
                                        stroke-linecap="round" />
                                </svg>

                                <!-- Icon 4: Laptop with Heart -->
                                <svg *ngIf="pkg.iconType === 'laptop-heart'" class="w-10 h-10" viewBox="0 0 48 48"
                                    fill="none">
                                    <rect x="10" y="14" width="28" height="18" rx="3" stroke="#2563EB"
                                        stroke-width="2.6" />
                                    <path d="M6 34H42C42 34 40 37 37 37H11C8 37 6 34 6 34Z" stroke="#2563EB"
                                        stroke-width="2.6" stroke-linejoin="round" />
                                    <path
                                        d="M24 20C22.8 18.8 20.8 19.2 20.8 21.2C20.8 23.2 24 25.6 24 25.6C24 25.6 27.2 23.2 27.2 21.2C27.2 19.2 25.2 18.8 24 20Z"
                                        fill="#2563EB" stroke="#1D4ED8" stroke-width="1.2" />
                                </svg>
                            </div>

                            <!-- Package Title & Subtitle -->
                            <div class="mt-2.5 mb-4 min-h-[58px]">
                                <h3 class="text-lg sm:text-xl font-bold text-[#102B51] leading-tight tracking-tight">
                                    {{ pkg.name }}
                                </h3>
                                <p class="text-xs text-gray-500 font-normal mt-1 leading-normal">
                                    {{ pkg.subtitle }}
                                </p>
                            </div>

                            <!-- Category Header -->
                            <h4 class="text-xs sm:text-[13px] font-bold text-[#102B51] tracking-wide mb-3">
                                {{ pkg.categoryLabel }}
                            </h4>

                            <!-- Features Checklist -->
                            <ul class="space-y-2.5">
                                <li *ngFor="let feat of pkg.features" class="flex items-start gap-2.5">
                                    <svg class="w-4 h-4 shrink-0 text-[#2563EB] mt-0.5" viewBox="0 0 20 20" fill="none">
                                        <circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.8" />
                                        <path d="M6.5 10.2L8.8 12.5L13.5 7.5" stroke="currentColor" stroke-width="2.2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <span class="text-xs sm:text-[13px] text-gray-700 font-medium leading-snug">
                                        {{ feat }}
                                    </span>
                                </li>
                                <!-- Expandable Additional Features -->
                                <ng-container *ngIf="pkg.showMore">
                                    <li *ngFor="let moreFeat of pkg.moreFeatures"
                                        class="flex items-start gap-2.5 animate-fade-in">
                                        <svg class="w-4 h-4 shrink-0 text-[#2563EB] mt-0.5" viewBox="0 0 20 20"
                                            fill="none">
                                            <circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.8" />
                                            <path d="M6.5 10.2L8.8 12.5L13.5 7.5" stroke="currentColor"
                                                stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <span class="text-xs sm:text-[13px] text-gray-700 font-medium leading-snug">
                                            {{ moreFeat }}
                                        </span>
                                    </li>
                                </ng-container>
                            </ul>

                            <!-- Show More Toggle Button -->
                            <div *ngIf="pkg.moreFeatures && pkg.moreFeatures.length > 0"
                                class="h-9 flex items-center justify-start mt-auto pt-2">
                                <button type="button" (click)="toggleShowMore(pkg, $event)"
                                    class="text-[#2563EB] hover:text-[#1D4ED8] text-sm font-semibold italic inline-flex items-center gap-2 transition-colors cursor-pointer py-1">
                                    <span>{{ pkg.showMore ? 'Show Less' : 'Show More' }}</span>
                                    <span
                                        class="w-5 h-5 rounded-full border border-[#2563EB] flex items-center justify-center transition-transform duration-300 text-[#2563EB] font-bold text-xs"
                                        [class.rotate-180]="!pkg.showMore">
                                        ↑
                                    </span>
                                </button>
                            </div>
                        </div>

                        <!-- Separate Bonus Section -->
                        <div class="w-full mt-auto">
                            <div class="w-full border-t-2 border-[#1E2B58] my-4"></div>
                            <div class="text-left w-full mb-1">
                                <h4 class="text-xl font-bold text-[#1E2B58] mb-1">Bonus</h4>
                                <p class="text-base sm:text-lg font-semibold text-[#1E2B58]">
                                    {{ pkg.bonus || (pkg.bonuses && pkg.bonuses.length > 0 ? pkg.bonuses[0] : '-') }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Bottom Price & Action Button Section -->
                    <div class="pt-4 border-t border-gray-100/90 flex items-end justify-between gap-2 mt-2">
                        <!-- Price Info -->
                        <div>
                            <span class="block text-[11px] sm:text-xs font-bold text-[#2563EB] tracking-wide mb-0.5">
                                Harga:
                            </span>
                            <div class="text-lg sm:text-xl font-extrabold text-[#102B51] tracking-tight leading-tight">
                                {{ pkg.priceFormatted }}
                            </div>
                            <div
                                class="text-xs sm:text-[13px] text-gray-400 line-through decoration-[#EF4444] decoration-[1.8px] font-medium mt-0.5">
                                {{ pkg.originalPriceFormatted }}
                            </div>
                        </div>

                        <!-- Rounded-Square Right Arrow Action Button -->
                        <button (click)="orderPackage(pkg)"
                            class="w-11 h-11 sm:w-12 sm:h-12 rounded-2xl border-2 border-[#102B51] hover:bg-[#102B51] text-[#102B51] hover:text-white flex items-center justify-center transition-all duration-300 shadow-sm hover:shadow-md cursor-pointer shrink-0 active:scale-95 group/btn"
                            [title]="'Pesan ' + pkg.name" [attr.aria-label]="'Pesan ' + pkg.name">
                            <svg class="w-5 h-5 sm:w-6 sm:h-6 transition-transform group-hover/btn:translate-x-0.5"
                                fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"
                                aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"></path>
                            </svg>
                        </button>
                    </div>

                </div>

            </div>

        </div>

    </section>

</div>